/**
 * assets.js
 *
 * Centralizes all static asset imports so no component or hook
 * needs to manage its own image paths.
 *
 * Tile images extracted from App.js lines 3–18.
 * SONAR_IMAGES array extracted from App.js line 52.
 */

// Grid tile states
import tileUnselected from '../assets/tile_unselected.png';
import tileAvailable  from '../assets/tile_available.png';
import tileSnag       from '../assets/tile_snag.png';
import tileFish       from '../assets/tile_fish.png';
import flagDecal      from '../assets/flag_decal.png';

// Sonar count tiles (0–8 surrounding snags)
import tile0 from '../assets/tile0.png';
import tile1 from '../assets/tile1.png';
import tile2 from '../assets/tile2.png';
import tile3 from '../assets/tile3.png';
import tile4 from '../assets/tile4.png';
import tile5 from '../assets/tile5.png';
import tile6 from '../assets/tile6.png';
import tile7 from '../assets/tile7.png';
import tile8 from '../assets/tile8.png';


import coinIcon from '../assets/coin.png';
import starIcon from '../assets/star.png';

export { tileUnselected, tileAvailable, tileSnag, tileFish, flagDecal, coinIcon, starIcon };

// Indexed array so GameBoard can do SONAR_IMAGES[count] directly
export const SONAR_IMAGES = [tile0, tile1, tile2, tile3, tile4, tile5, tile6, tile7, tile8];

// Default sprite heights for full-size display contexts
export const DEFAULT_CATCH_SPRITE_HEIGHT     = 180; // CatchScreen + FishDetailOverlay
export const DEFAULT_DIRECTORY_SPRITE_HEIGHT = 160; // DirectoryDetailCard

// Per-species overrides for oversized sprites.
// Add new entries here whenever a fish sprite exceeds the default display height.
export const FISH_SPRITE_HEIGHTS = {
  swordfish: 155,  
  shark:     155,  
  whale:     115,
  kraken:    180, 
  megalodon: 140, 
};